<script setup lang="ts">
    import { useI18n } from 'vue-i18n'

    /**
     * Marks a tool that asks the user to confirm before running
     * (docs/specs/tool-approval-interface.md). Shown only on gated tools, in
     * every surface that lists configurable tools: the agent panel, the MCP
     * server dialog and the API tools table.
     *
     * Read-only on purpose: the control that toggles the flag lives next to the
     * tool's own settings, this only makes a long list scannable.
     */
    const { t: $t } = useI18n({ useScope: 'global' })
</script>

<template>
    <VvBadge
        modifiers="sm warning"
        class="inline-flex items-center gap-4 shrink-0">
        <VvIcon name="ri:shield-user-line" class="text-10" />
        {{ $t('label.toolApprovalBadge') }}
    </VvBadge>
</template>
